import { Box } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import Calendar from "../../../Assets/icon/incompleted-link/calendar.svg";
import Coin from "../../../Assets/icon/incompleted-link/coin.svg";
import Resume from "../../../Assets/icon/incompleted-link/resume.svg";
import Badge from "../../../Assets/icon/incompleted-link/purple-badge.svg";
import { Link } from "react-router-dom";

const Container = styled.div`
  margin-top: 50px;
  width: 100%;
  img {
    margin-bottom: 15px;
    width: 50px;
  }
  .text {
    color: #333333;
    font-family: Fa_IRANSansBold;
    font-weight: 900;
    font-size: 1rem;
  }
  .badge {
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url(${Badge}) no-repeat center center;
    background-size: cover;
    font-weight: bold;
    color: #ffffff;
    position: absolute;
    top: -10px;
    right: -10px;
  }
`;
const IncompletedLinks = () => {
  return (
    <Container>
      <Box
        width="100%"
        display="flex"
        justifyContent="space-around"
        alignItems="center"
      >
        <Link to={"/profile"}>
          <Box
            position="relative"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <span className="badge">1</span>
            <img alt="#" src={Resume} />
            <div className="text">تکمیل پروفایل</div>
          </Box>
        </Link>
        <Link to="/profile/weekly">
          <Box
            position="relative"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <span className="badge">2</span>
            <img alt="#" src={Calendar} />
            <div className="text">زمان بندی کلاس</div>
          </Box>
        </Link>
        <Link to="/profile/lessons">
          <Box
            position="relative"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <span className="badge">3</span>
            <img alt="#" src={Coin} />
            <div className="text">قیمت گذاری</div>
          </Box>
        </Link>
      </Box>
    </Container>
  );
};

export default IncompletedLinks;
